import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import {
    MatLegacyDialog as MatDialog,
    MatLegacyDialogRef as MatDialogRef,
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RedirectInfo, LicenseRedirectPopupData } from '../providers/license-redirect.types';
import { LicenseRedirectService } from 'providers/license-redirect.service';
import { AuthService } from 'providers/auth.service';

interface PopupContent {
    title: string;
    description: string;
    targetDescription: string;
    buttonText: string;
    targetPlatform: string;
}

@Component({
    selector: 'ce-license-redirect-popup',
    templateUrl: './license-redirect-popup.component.html',
    styleUrls: ['./license-redirect-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
@UntilDestroy()
export class LicenseRedirectPopupComponent {
    redirectInfo: RedirectInfo;
    popupContent: PopupContent;

    static open(matDialog: MatDialog, dialogData: LicenseRedirectPopupData) {
        return matDialog.open(LicenseRedirectPopupComponent, {
            data: dialogData,
            disableClose: true, // Prevent closing by clicking outside or ESC
        });
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) dialogData: LicenseRedirectPopupData,
        private readonly dialogRef: MatDialogRef<LicenseRedirectPopupComponent>,
        private readonly licenseRedirectService: LicenseRedirectService,
        private readonly cdRef: ChangeDetectorRef,
        private readonly authService: AuthService
    ) {
        this.redirectInfo = dialogData.redirectInfo;
        this.popupContent = this.generatePopupContent(this.redirectInfo);
    }

    private generatePopupContent(_redirectInfo: RedirectInfo): PopupContent {
        return {
            title: 'Redirecting to MyKempower',
            description: "Your primary subscription is for MyKempower, but you're trying to login to ChargEye.",
            targetDescription:
                "You'll be redirected to MyKempower to access your subscription features and continue your session.",
            buttonText: 'Continue to MyKempower',
            targetPlatform: 'MyKempower',
        };
    }

    onContinueClick(): void {
        this.dialogRef.close();

        // Perform the actual redirect through the redirect service
        // Always redirects to MyKempower (the only supported redirect direction)
        this.licenseRedirectService.performRedirectFromPopup();
    }

    onLogoutClick(): void {
        this.dialogRef.close();
        this.authService.logout();
    }
}
